import { createListenerMiddleware, type TypedStartListening } from '@reduxjs/toolkit';
import { baseApi } from '@/app/baseApi';
import { signedIn, signedOut } from './authSlice';
import { tokenStorage } from './tokenStorage';
import type { AppDispatch, RootState } from '@/app/store';

export const authListenerMiddleware = createListenerMiddleware();

const startListening = authListenerMiddleware.startListening as TypedStartListening<RootState, AppDispatch>;

startListening({
  actionCreator: signedOut,
  effect: (_action, { dispatch }) => {
    dispatch(baseApi.util.resetApiState());
  },
});

export function syncAuthAcrossTabs(dispatch: AppDispatch, getState: () => RootState): () => void {
  return tokenStorage.subscribe((tokens) => {
    const { isAuthenticated } = getState().auth;

    if (tokens && !isAuthenticated)
      dispatch(signedIn());

    if (!tokens && isAuthenticated)
      dispatch(signedOut());
  });
}
